// extracted by mini-css-extract-plugin
export default {"mainTitle":"BecomeLessee_mainTitle__cNrog","mainPicture":"BecomeLessee_mainPicture__RwVWi","borderBackground":"BecomeLessee_borderBackground__f9PPB"};